import VideoBase from "./VideoBase";

/** Get ID of a youtube video from URL
* @param {string} url
* @return {string} youtube video ID
*/
export const youtubeGetId = (url) => {
  const parts = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if (parts[2] !== undefined) {
    return parts[2].split(/[^0-9a-z_-]/i)[0];
  }
  return url;
}

export default class Youtube extends VideoBase {
  _load = () => {
    return this.theme.loadYoutubeApi();
  }

  init = ({ autoplay, hideControls, url, mute, loop, onPlay, onEnd }) => {
    autoplay = this.getAutoplay(autoplay);

    const videoId = youtubeGetId(url);
    return new Promise((resolve) => {
      this._load().then(
        (YT) => {
          this.player = new YT.Player(this.element, {
            videoId: videoId,
            playerVars: {
              showinfo: 0,
              modestbranding: 1,
              rel: 0,
              autoplay: autoplay ? 1 : 0,
              controls: hideControls ? 0 : 1,
              mute: mute || autoplay ? 1 : 0,
              playlist: videoId,
              cc_load_policy: 0,
              fs: 0,
              iv_load_policy: 3,
              playsinline: 1,
              branding: 0,
              origin: window.location.origin,
            },
            events: {
              onReady: (event) => {
                this.player = event.target;

                if (mute || autoplay) {
                  this.player.mute();
                }

                if (autoplay) {
                  // Force play just in case that the option didn't work
                  this.player.playVideo();
                }

                resolve(this.player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  onPlay();
                }

                if (event.data === YT.PlayerState.ENDED && loop) {
                  this.player.playVideo();
                  onEnd();
                }
              }
            },
          });
        }
      )
    });
  }

  play = () => {
    this.player.playVideo();
  }
}
